import {SharedColors} from "@fluentui/theme";
import {Text} from "@fluentui/react";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {IModelError} from "../interfaces/IModelError";
import "../styles/ShowApiError.css";
import {AxiosError} from "axios";
import i18n from "i18next";

interface IShowApiErrorProps<T> {
    errors: IModelError<T> | undefined;
    keys?: Array<keyof T | ""> | undefined;
    transform?: (s: string) => string;
    children?: any;
}

export const GetApiError = <T extends any>(
    Errors: any,
    ...keys: (keyof T | "")[]
) => {
    let ret = LocalGetApiError(Errors, ...keys);

    if (ret) ret = i18n.t(ret);

    return ret;
};

const LocalGetApiError = <T extends any>(
    Errors: any,
    ...keys: (keyof T | "")[]
) => {
    if (Errors instanceof AxiosError) {
        Errors = Errors.response?.data;
    }
    if (Errors?.errors) {
        Errors = Errors.errors;
    }
    if (typeof Errors === "string") {
        return Errors;
    }
    if (!keys || keys.length == 0) {
        if (typeof Errors === "string") {
            return Errors;
        }
        if (Errors) {
            const keys = Object.keys(Errors);
            if (keys.length) {
                const errorKey = keys[0];
                if (errorKey != undefined) {
                    const err = Errors[errorKey].length
                        ? typeof Errors[errorKey] === "string"
                            ? Errors[errorKey]
                            : Errors[errorKey][0]
                        : undefined;
                    if (err) return err;
                }
            } else {
                return undefined;
            }
        }
    } else {
        const len = keys.length;
        for (let i = 0; i < len; i++) {
            const key = keys[i] as any;
            if (Errors) {
                const errorKey = Object.keys(Errors as any).find(
                    (k) => k.toLowerCase() === key.toLowerCase(),
                );
                if (errorKey != undefined) {
                    const err = Errors[errorKey].length
                        ? typeof Errors[errorKey] === "string"
                            ? Errors[errorKey]
                            : Errors[errorKey][0]
                        : undefined;
                    if (err) return err;
                }
            }
        }
    }
};

export const AlertApiError = <T extends any>(
    Errors: any,
    ...keys: (keyof T | "")[]
) => {
    const error = GetApiError(Errors, ...keys);
    if (error) {
        alert(error);
    }
};

export const ShowApiError = <T extends any>({
                                                errors,
                                                keys,
                                                transform,
                                            }: IShowApiErrorProps<T>) => {
    const {t} = useTranslation();
    const [hidden, setHidden] = useState(false);

    const apiError = useMemo(() => {
        return GetApiError<T>(errors, ...(keys ?? []));
    }, [errors, keys]);

    useEffect(() => {
        setHidden(false);
    }, [errors, keys]);

    const onErrorClicked = useCallback(() => {
        setHidden(true);
    }, []);

    if (!!apiError && !hidden)
        return (
            <div style={{display: "flex"}}>
                <Text
                    variant={"small"}
                    onClick={onErrorClicked}
                    role="alert"
                    className="ease-in-api-error"
                    styles={{root: {color: SharedColors.red20}}}
                >
                    {transform
                        ? transform(apiError?.trim()?.replace(/^\s+|\s+$/g, ""))
                        : apiError?.trim()?.replace(/^\s+|\s+$/g, "")}
                </Text>
            </div>
        );

    return null;
};
